import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-m-tileview",
  "use": "icon-m-tileview-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-m-tileview\"><path d=\"M7 12h7v7H7zm0 10h7v7H7zm10-10h7v7h-7zm10 0h7v7h-7zM17 22h7v7h-7zm10 0h7v7h-7z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol